import { ADOBE_EXIT_LINK_CLICK, ADOBE_LINK_CLICK, ADOBE_PAGE_LOAD, ADOBE_TRANSACTION } from 'src/app/shared/utils/adobe-analytics-consts';
import { getPageData, userDataAnalytics } from '../../shared/utils/adobe-analytics-utils';
import {
  TRACK_FUND_SWITCH,
  TRACK_GASA_STATUS,
  TRACK_LINK_TYPE,
  TRACK_PAGE_NAME,
  TRANSACTION_NAME
} from './constants';
import {
  TrackButtonParams,
  TrackLinkParams
} from './models/gasa-adobe-analytics-model';

declare global {
  interface Window {
    adobeDataLayer: any;
  }
}
declare const window: Window &
  typeof globalThis & {
    adobeDataLayer: any;
  };

window.adobeDataLayer = [];
const dataLayer = window.adobeDataLayer;

/**
 * Function to track page view/loading via adobe analytics
 * @param pageName name of the page i.e. loaded
 */
export async function trackPageLoad(pageName: string, userData: any = {}) {
  console.log('Tracking page load ', userData);
  if (pageName === TRACK_PAGE_NAME.policyDetailsPage)
    dataLayer.push(
      {
        event: ADOBE_PAGE_LOAD,
        page: getPageData(pageName),
        user: await userDataAnalytics({ id: '' , cwsId:userData?.custom_attributes?.MLJ_CWS_ID__c}),
        policy: [
          {
            type: '',
            name: 'GASA用',
            number: '',
          },
        ],
      }
    );
  else if (pageName == TRACK_PAGE_NAME.surrenderReqTypeAPage || pageName == TRACK_PAGE_NAME.surrenderReqTypeBPage || pageName == TRACK_PAGE_NAME.surrederReqTypeCpage) {
    dataLayer.push(
      {
        event: ADOBE_PAGE_LOAD,
        page: getPageData(pageName),
        user: await userDataAnalytics({ id: '' , cwsId:userData?.custom_attributes?.MLJ_CWS_ID__c}),
        policy: [
          {
            type: "",
            name: "GASA用",
            number: "",
          },
        ],
      }
    )
  }
  else
    dataLayer.push(
      {
        event: ADOBE_PAGE_LOAD,
        page: getPageData(pageName),
        user: await userDataAnalytics({ id: '' , cwsId:userData?.custom_attributes?.MLJ_CWS_ID__c}),
      }
    );
}

/**
 * Function to track link click via adobe analytics
 * @param type type of link whether it's internal or external
 * @param params parameters to be send to tracking event
 */
export function trackLinkClick(params: TrackLinkParams, type?: string) {
  let eventInfo;
  if (type == TRACK_LINK_TYPE.external) {
    eventInfo = {
      event: ADOBE_EXIT_LINK_CLICK,
      eventInfo: {
        exitLink: {
          label: params?.label,
          url: params?.url,
        },
      },
    };
  } else {
    eventInfo = {
      event: ADOBE_LINK_CLICK,
      eventInfo: {
        click: {
          linkName: params?.label,
          linkHref: params?.url || '',
        },
      },
    };
  }
  dataLayer.push(eventInfo);
}

/**
 * Function to track button click via adobe analytics
 * @param params parameters to be send to tracking event
 */

//no button clicks, all button clicks will be considered as internal link clicks
export function trackButtonClick(params: TrackButtonParams) {
  dataLayer.push(
    {
      event: 'buttonClick',
      eventInfo: {
        button: {
          label: params?.label,
          link: params?.link,
        },
      },
    }
  );
}

/**
 * Function to track fund switching via adobe analytics
 * @param status type of switching event whether it's start, complete or cancel
 */
export function trackFundSwitch(status: string) {
  let eventInfo;
  switch (status) {
    case TRACK_FUND_SWITCH.start:
      eventInfo = {
        event: ADOBE_TRANSACTION.START,
        eventInfo: {
          transaction: {
            transactionName: TRANSACTION_NAME.fundSwitch,
          },
        },
      };
      break;
    case TRACK_FUND_SWITCH.complete:
      eventInfo = {
        event: ADOBE_TRANSACTION.COMPLETE,
        eventInfo: {
          transaction: {
            transactionName: TRANSACTION_NAME.fundSwitch,
            transactionValue: {
              data: {
                userId: '',
              },
            },
          },
        },
      };
      break;
    case TRACK_FUND_SWITCH.cancel:
      eventInfo = {
        event: ADOBE_TRANSACTION.ERROR,
        eventInfo: {
          transaction: {
            transactionName: TRANSACTION_NAME.fundSwitch,
            transactionValue: {
              data: {
                userId: '',
              },
            },
          },
        },
      };
      break;
  }
  dataLayer.push(eventInfo);
}

/**
 * Function to track showing popup via adobe analytics
 * @param title title of the popup
 */
export function trackPopup(title: string) {
  dataLayer.push(
    {
      event: 'popUpDisplay',
      eventInfo: {
        popup: {
          title: title,
        },
      },
    }
  );
}

/**
 * Function to track gasa cancellation status via adobe analytics
 * @param transactionStatus type of transaction status whether it's start, complete or cancel
 */
export function trackGasaCancellationTransaction(transactionStatus: string) {
  let eventInfo;
  switch (transactionStatus) {
    case TRACK_GASA_STATUS.start:
      eventInfo = {
        event: ADOBE_TRANSACTION.START,
        eventInfo: {
          transactionName: TRANSACTION_NAME.gasaCancellation,
          transactionValue: {
            data: {
              userId: '',
            },
          },
        },
      };
      break;
    case TRACK_GASA_STATUS.complete:
      eventInfo = {
        event: ADOBE_TRANSACTION.COMPLETE,
        eventInfo: {
          transactionName: TRANSACTION_NAME.gasaCancellation,
          transactionValue: {
            data: {
              userId: '',
            },
          },
        },
      };
      break;
    case TRACK_GASA_STATUS.cancel:
      eventInfo = {
        event: ADOBE_TRANSACTION.ERROR,
        eventInfo: {
          transaction: {
            transactionName: TRANSACTION_NAME.gasaCancellation,
            transactionValue: {
              data: {
                userId: '',
              },
            },
          },
        },
      };
      break;
  }
  dataLayer.push(eventInfo);
}

export * as GasaAdobeAnalytics from './gasa-adobe-analytics';

